import { Message } from "@/types/chat";

// Shared types for stores
export interface User {
  id: number;
  email: string;
  name?: string;
}

export interface SavedSection {
  id: string;
  isCollapsed: boolean;
  isDisabled: boolean;
}

export type GradingViewLayout = SavedSection[];

export interface GoogleDriveGalleryState {
  isOpen?: boolean;
  galleryUrl?: string | null;
}

export interface GalleryState {
  isOpen?: boolean;
  currentImageUrl?: string | null;
}

export interface FinalizationState {
  selectedWinnerId: string;
  selectedWinnerContent: string;
  isFinalizationEnabled: boolean;
}

// export interface ChatMessage {
//   timestamp: Date | string;
//   [key: string]: unknown;
// }

export const defaultProfileStates: {
  assessmentState: AssessmentState;
} = {
  assessmentState: {
    galleryState: {
      isOpen: false,
      currentImageUrl: null,
    },
    chatMessages: [],
    teacherNotes: "",
    finalizationState: {
      selectedWinnerId: "",
      selectedWinnerContent: "",
      isFinalizationEnabled: false,
    },
    peerGalleryState: {
      isOpen: false,
      galleryUrl: null, // TODO: We shouldn't really need this.. we only care if it's open and if it is the assignment details has the peerGalleryDriveLink to use here
    },
    showPastReviewExamples: false,
    isGradingStarted: false,
  },
};

export interface AssessmentState {
  showPastReviewExamples: boolean;
  isGradingStarted: boolean;
  peerGalleryState: GoogleDriveGalleryState;
  galleryState: GalleryState;
  chatMessages?: Message[];
  teacherNotes?: string;
  finalizationState?: FinalizationState;
  gradingViewLayout?: GradingViewLayout;
}

export interface ProfileState {
  preferences?: {
    selectedModel?: string;
    includeImages?: boolean;
    systemPrompt?: string;
    teacherExamples?: string;
  };
}

export interface TeacherProfile {
  id: number;
  name: string;
  state: ProfileState;
}

export interface AssessmentData {
  answers?: Array<{
    answerData?: {
      downloads?: Array<{
        url: string;
        title: string;
        fileType: string;
      }>;
    };
  }>;
  learningUnit?: {
    id: string;
    title: string;
  };
  section?: {
    title: string;
    description: string;
  };
  assignmentDetails?: {
    id: number;
    isConfirmed: boolean;
    otsikko: string;
    alaotsikko: string | null;
    lukukausi: string;
    tehtävänanto: string;
    arviointiperusteet: string[];
    kuvat: string[];
    peerGalleryDriveLink: string | null;
  };
}
